import { environment } from 'environments/environment';
import  data from '../../../../app/config.json';
export class constant {
    public static get HOME_URL(): string {
         return localStorage.getItem('baseURL'); 
    }
}
